exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout-license-alert{margin:60px 0 -56px 60px}.layout-license-alert>div{display:flex;width:100%;justify-content:space-between;align-items:center}.layout-license-alert .v-btn{margin:0}\n", ""]);

// exports
